@if (primary) {
  <page-button
    [config]="primary"
    (clicked)="primaryAction()"
    [loading]="primLoading"
    [disabled]="primDisabled"
  ></page-button>
}
@if (secondary) {
  <page-button
    [config]="secondary"
    (clicked)="secondaryAction()"
    [loading]="secLoading"
    [disabled]="secDisabled"
    [style.margin]="layout === 'apart' ? '0 auto 0 0' : '0 0 0 auto'"
  ></page-button>
}
